"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Hierarchy4: ['hierarchy-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.75,18.748h0a6.291,6.291,0,0,1,6.545-6h3.41a6.291,6.291,0,0,1,6.545,6h0', 'M12 6.748L12 18.748', 'M9.000 3.748 A3.000 3.000 0 1 0 15.000 3.748 A3.000 3.000 0 1 0 9.000 3.748 Z', 'M1.500 20.998 A2.250 2.250 0 1 0 6.000 20.998 A2.250 2.250 0 1 0 1.500 20.998 Z', 'M9.750 20.998 A2.250 2.250 0 1 0 14.250 20.998 A2.250 2.250 0 1 0 9.750 20.998 Z', 'M18.000 20.998 A2.250 2.250 0 1 0 22.500 20.998 A2.250 2.250 0 1 0 18.000 20.998 Z']],
  Hierarchy6: ['hierarchy-6', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 15.748 L8.250 15.748 L8.250 23.248 L0.750 23.248 Z', 'M8.250 0.748 L15.750 0.748 L15.750 8.248 L8.250 8.248 Z', 'M15.750 15.748 L23.250 15.748 L23.250 23.248 L15.750 23.248 Z', 'M4.5,15.748v-1.5a1.5,1.5,0,0,1,1.5-1.5H18a1.5,1.5,0,0,1,1.5,1.5v1.5', 'M12 8.248L12 12.748']],
  Hierarchy1: ['hierarchy-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 20.998 A2.250 2.250 0 1 0 5.250 20.998 A2.250 2.250 0 1 0 0.750 20.998 Z', 'M6.000 8.998 A2.250 2.250 0 1 0 10.500 8.998 A2.250 2.250 0 1 0 6.000 8.998 Z', 'M13.500 14.998 A2.250 2.250 0 1 0 18.000 14.998 A2.250 2.250 0 1 0 13.500 14.998 Z', 'M18.750 2.998 A2.250 2.250 0 1 0 23.250 2.998 A2.250 2.250 0 1 0 18.750 2.998 Z', 'M3.902 18.936L7.348 11.06', 'M10.007 10.404L13.993 13.593', 'M20.098 5.06L16.652 12.936']],
  Hierarchy3: ['hierarchy-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 18.748 L14.250 18.748 L14.250 23.248 L0.750 23.248 Z', 'M9.750 11.248 L23.250 11.248 L23.250 15.748 L9.750 15.748 Z', 'M0.750 0.748 L14.250 0.748 L14.250 5.248 L0.750 5.248 Z', 'M6.75,5.248v1.5a1.5,1.5,0,0,0,1.5,1.5h4.5a1.5,1.5,0,0,1,1.5,1.5v1.5', 'M18.75,15.748v4.5a1.5,1.5,0,0,1-1.5,1.5h-3']],
  Hierarchy5: ['hierarchy-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.750 0.748 L19.750 0.748 L19.750 5.248 L4.750 5.248 Z', 'M12.25 5.248L12.25 18.748', 'M4.75,18.748v-4.5a1.5,1.5,0,0,1,1.5-1.5h12a1.5,1.5,0,0,1,1.5,1.5v4.5', 'M2.500 20.998 A2.250 2.250 0 1 0 7.000 20.998 A2.250 2.250 0 1 0 2.500 20.998 Z', 'M10.000 20.998 A2.250 2.250 0 1 0 14.500 20.998 A2.250 2.250 0 1 0 10.000 20.998 Z', 'M17.500 20.998 A2.250 2.250 0 1 0 22.000 20.998 A2.250 2.250 0 1 0 17.500 20.998 Z']],
  Hierarchy9: ['hierarchy-9', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 10.498 A3.750 3.750 0 1 0 17.250 10.498 A3.750 3.750 0 1 0 9.750 10.498 Z', 'M18.750 2.998 A2.250 2.250 0 1 0 23.250 2.998 A2.250 2.250 0 1 0 18.750 2.998 Z', 'M18.750 15.748 A2.250 2.250 0 1 0 23.250 15.748 A2.250 2.250 0 1 0 18.750 15.748 Z', 'M11.250 20.998 A2.250 2.250 0 1 0 15.750 20.998 A2.250 2.250 0 1 0 11.250 20.998 Z', 'M0.750 20.998 A2.250 2.250 0 1 0 5.250 20.998 A2.250 2.250 0 1 0 0.750 20.998 Z', 'M1.500 5.248 A2.250 2.250 0 1 0 6.000 5.248 A2.250 2.250 0 1 0 1.500 5.248 Z', 'M16.151 7.848L19.411 4.588', 'M16.794 12.292L19.079 14.577', 'M13.5 14.248L13.5 18.748', 'M10.851 13.147L4.59 19.408', 'M10.001 9.149L5.61 6.514']],
  HierarchyFiles: ['hierarchy-files', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,23.248H21a.75.75,0,0,0,.75-.75V17.559a.75.75,0,0,0-.219-.53l-1.06-1.061a.749.749,0,0,0-.53-.22H16.5a.75.75,0,0,0-.75.75v6A.75.75,0,0,0,16.5,23.248Z', 'M16.5,9.748H21A.75.75,0,0,0,21.75,9V4.059a.75.75,0,0,0-.219-.53l-1.06-1.061a.749.749,0,0,0-.53-.22H16.5a.75.75,0,0,0-.75.75V9A.75.75,0,0,0,16.5,9.748Z', 'M2.25 0.748L2.25 2.248', 'M2.25 5.248L2.25 8.248', 'M2.25 11.248L2.25 14.248', 'M2.25,17.248v1.5a1.5,1.5,0,0,0,1.5,1.5h1.5', 'M8.25 20.248L11.25 20.248', 'M14.25 20.248L15.75 20.248', 'M2.25 6.748L5.25 6.748', 'M8.25 6.748L11.25 6.748', 'M14.25 6.748L15.75 6.748']],
  Hierarchy7: ['hierarchy-7', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 18.748 A4.500 4.500 0 1 0 9.750 18.748 A4.500 4.500 0 1 0 0.750 18.748 Z', 'M14.250 18.748 A4.500 4.500 0 1 0 23.250 18.748 A4.500 4.500 0 1 0 14.250 18.748 Z', 'M7.500 5.248 A4.500 4.500 0 1 0 16.500 5.248 A4.500 4.500 0 1 0 7.500 5.248 Z', 'M16.738 14.724L14.012 9.273', 'M9.75 18.748L14.25 18.748', 'M9.988 9.273L7.262 14.724']],
  Hierarchy: ['hierarchy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 2.998 A2.250 2.250 0 1 0 14.250 2.998 A2.250 2.250 0 1 0 9.750 2.998 Z', 'M9.750 20.998 A2.250 2.250 0 1 0 14.250 20.998 A2.250 2.250 0 1 0 9.750 20.998 Z', 'M1.500 20.998 A2.250 2.250 0 1 0 6.000 20.998 A2.250 2.250 0 1 0 1.500 20.998 Z', 'M18.000 20.998 A2.250 2.250 0 1 0 22.500 20.998 A2.250 2.250 0 1 0 18.000 20.998 Z', 'M3.75,18.748h0a6,6,0,0,1,6-6h4.5a6,6,0,0,1,6,6h0', 'M12 5.248L12 18.748']],
  Hierarchy10: ['hierarchy-10', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 3.748 A3.000 3.000 0 1 0 6.750 3.748 A3.000 3.000 0 1 0 0.750 3.748 Z', 'M0.750 14.998 A3.000 3.000 0 1 0 6.750 14.998 A3.000 3.000 0 1 0 0.750 14.998 Z', 'M17.250 8.998 A3.000 3.000 0 1 0 23.250 8.998 A3.000 3.000 0 1 0 17.250 8.998 Z', 'M17.250 20.248 A3.000 3.000 0 1 0 23.250 20.248 A3.000 3.000 0 1 0 17.250 20.248 Z', 'M6.62 4.661L17.381 8.085', 'M6.434 16.341L17.286 19.794', 'M6.371 13.537L17.565 10.338']],
  Hierarchy8: ['hierarchy-8', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 5.248 A3.000 3.000 0 1 0 15.000 5.248 A3.000 3.000 0 1 0 9.000 5.248 Z', 'M0.750 18.748 A3.000 3.000 0 1 0 6.750 18.748 A3.000 3.000 0 1 0 0.750 18.748 Z', 'M17.250 18.748 A3.000 3.000 0 1 0 23.250 18.748 A3.000 3.000 0 1 0 17.250 18.748 Z', 'M6.75 18.748L17.25 18.748', 'M13.659 7.748L18.941 16.048', 'M10.341 7.748L5.059 16.048']],
  Hierarchy2: ['hierarchy-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 18.748 L23.250 18.748 L23.250 23.248 L9.750 23.248 Z', 'M9.750 11.248 L23.250 11.248 L23.250 15.748 L9.750 15.748 Z', 'M0.750 0.748 L14.250 0.748 L14.250 5.248 L0.750 5.248 Z', 'M6.75,5.248v1.5a1.5,1.5,0,0,0,1.5,1.5h4.5a1.5,1.5,0,0,1,1.5,1.5v1.5', 'M17.25 15.748L17.25 18.748']]
};
exports["default"] = _default;